import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Input, Button, message } from "antd";
import { req_edit_afs_scholarshipsform } from "../../api";

class RejectCaseModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    scholarship: PropTypes.object.isRequired,
  };

  state = { description: "審查不通過" };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_afs_scholarshipsform(item, token);
    if (result.status === "success") {
      message.success(result.message);
    }
  };

  onInputChange = (event) => {
    const { value } = event.target;
    this.setState({ description: value });
  };

  onSaveChange = () => {
    const { scholarship } = this.props;
    const { description } = this.state;
    const { Uid } = scholarship;
    const { userCode } = this.props.user;
    const row_reject = {
      Uid: Uid,
      ReviewerCode: userCode,
      AuditResults: "FAIL",
      AuditDescription: description,
      condition: "BASE",
    };
    this.api_edit_item(row_reject);
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { description } = this.state;
    return (
      <div>
        <p></p>
        <Input
          placeholder="請輸入不通過說明"
          defaultValue={description}
          onChange={this.onInputChange}
          style={{ backgroundColor: "LightYellow" }}
        />
        <p></p>
        <Button type="primary" onClick={this.onSaveChange} block>
          送出
        </Button>
      </div>
    );
  }
}
export default connect((state) => ({ user: state.user }), {})(RejectCaseModal);
